import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { useApi } from '@/shared/composables/api'
import { Group } from '@/shared/types/api'

export const useStoreGroups = defineStore('groups', () => {
  const groups = ref<Array<Group>>([])

  const groupNamesMap = computed(() => {
    return groups.value.reduce((acc, group) => {
      acc[group.guid] = group.name
      return acc
    }, {} as Record<string, string>)
  })

  const userGroupsArr = computed(() => groups.value.filter(group => group.type === 'user'))

  const userGroupsObj = computed<{ [guid: string]: true }>(() => groups.value.reduce((acc, group) => {
    if (group.type === 'user') {
      return { ...acc, [group.guid]: true }
    } else {
      return acc
    }
  }, {}))

  const getUserGroups = (groupIds: string[]) => groups.value.filter((group) => {
    if (groupIds.includes(group.guid)) {
      return group
    }
    return
  })

  const load = (): Promise<Array<Group>> => {
    return new Promise((resolve, reject) => {
      const api = useApi()
      api.getGroups().then((response) => {
        const data = response.data
        groups.value = data
        resolve(data)
      }).catch(reject)
    })
  }

  return {
    groups,
    groupNamesMap,
    userGroupsArr,
    userGroupsObj,
    getUserGroups,
    load,
  }
})
